import { autoinject, BindingEngine, customElement } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { UsersLocationsMapFilter } from 'model/users-locations';
import { KeywordsService } from 'services/keywords-service';
import { ModelBase } from 'support/base_classes/model-base';

@autoinject
@customElement('users-locations-map-filter')
export class UsersLocationsMapFilterCustomElement extends ModelBase<UsersLocationsMapFilter> {
  @bindable disabled = false;

  constructor(private keywords: KeywordsService, bindingEngine: BindingEngine) {
    super(bindingEngine);
  }
}
